module.exports = __webpack_public_path__ + "img/pg.2a2bedae.svg";